import City, { cityDefaultProps } from "../models/City";
import CityApi from "./CityApi";

export class CityStore {
  cities: City[] = [];
  city: City = { ...cityDefaultProps };
  filteredCities: City[] = [];

  corCity: City = { ...cityDefaultProps };
  filteredCorCities: City[] = [];

  async loadCities() {
    this.cities = await CityApi.getAll();
  }

  async loadCityByPostCode(cityPostCode: number) {
    this.city = await CityApi.getByPostCode(cityPostCode);
  }

  async loadCorCityByPostCode(corCityPostCode: number) {
    this.corCity = await CityApi.getByPostCode(corCityPostCode);
  }

  async filterCitiesByName(cityName: string) {
    this.filteredCities = await CityApi.getCitiesByName(cityName);
  }

  findCityByPostCode(postCode: string): string {    
    if (postCode.length > 3) {
      const found = this.cities.find((x) => x.postCode == postCode);      
      if (found) {
        return found.name;
      }
    }
    return "";
  }
}

const store = new CityStore();
export default store;
